// Mock Data for Sauce Sity Barbershop App

// Membership Plans
export const membershipPlans = [
  {
    id: 1,
    name: 'Sauce Sity Regular',
    price: 29.99,
    interval: 'month',
    benefits: [
      'Priority booking access',
      'Extended hours: 8 AM - 7 PM (non-members: 9 AM - 5:30 PM)',
      'Recurring appointments (auto-book weekly, bi-weekly, or monthly)',
      'Book holiday appointments 2 months early',
      'Birthday discount 10% off',
      'Free beard trims and lineup between services',
      'Complimentary snack or drink of choice'
    ],
    color: 'purple'
  },
  {
    id: 2,
    name: 'The Gentleman',
    price: 49.99,
    interval: 'month',
    benefits: [
      'Priority booking access',
      'Extended hours: 8 AM - 7 PM (non-members: 9 AM - 5:30 PM)',
      'Recurring appointments (auto-book weekly, bi-weekly, or monthly)',
      'Book holiday appointments 2 months early',
      'Birthday discount 15% off',
      'Free beard trims and lineups between services',
      'Free steam facials',
      'Complimentary snack or drink of choice',
      '10% off merch and additional products',
      'First notification when someone cancels'
    ],
    color: 'lime',
    featured: true
  }
];

// Loyalty Rewards
export const loyaltyRewards = [
  {
    id: 1,
    name: 'Free Lineup',
    pointsRequired: 200,
    description: 'Clean edge-up and line definition',
    icon: '✨'
  },
  {
    id: 2,
    name: 'Free Lineup & Beard Trim',
    pointsRequired: 250,
    description: 'Lineup with professional beard trimming',
    icon: '✂️'
  },
  {
    id: 3,
    name: 'Free Haircut & Beard Trim',
    pointsRequired: 350,
    description: 'Complete grooming package',
    icon: '💈'
  }
];

// Points earning rate: 1 point per $5 spent
export const POINTS_PER_DOLLAR = 0.4; // 2 points per $5 = 0.4 points per $1

// Referral Rewards
export const referralRewards = [
  {
    id: 1,
    type: 'booking',
    name: '10% Off Next Cut',
    description: 'When your friend books their first haircut',
    icon: '✂️',
    referralsNeeded: 1,
    discount: 10
  },
  {
    id: 2,
    type: 'membership',
    name: '25% Off Next Cut',
    description: 'When your friend signs up for membership',
    icon: '👑',
    referralsNeeded: 1,
    discount: 25
  },
  {
    id: 3,
    type: 'milestone',
    name: 'FREE Haircut',
    description: 'Refer 3 friends to membership',
    icon: '🎉',
    referralsNeeded: 3,
    discount: 100
  }
];

export const services = [
  {
    id: 1,
    name: 'Adult Haircut',
    price: 0,
    duration: 30,
    description: 'Professional haircut for adults'
  },
  {
    id: 2,
    name: 'Lineup & Beard Trim',
    price: 0,
    duration: 20,
    description: 'Clean lineup with professional beard trimming'
  },
  {
    id: 3,
    name: 'Kids Haircut',
    price: 0,
    duration: 25,
    description: 'Haircut for children'
  },
  {
    id: 4,
    name: 'Razor Shave',
    price: 0,
    duration: 30,
    description: 'Clean razor shave'
  },
  {
    id: 5,
    name: 'Haircut & Dye',
    price: 0,
    duration: 50,
    description: 'Complete haircut with professional coloring (45-60 mins)'
  }
];

export const barbers = [
  {
    id: 1,
    name: 'Taine (Sauce)',
    specialty: 'Fades & Modern Cuts',
    avatar: 'https://customer-assets.emergentagent.com/job_barber-cape-coral/artifacts/nahy8chd_b651df64-3e71-44de-bdcc-8193c26fe087-1_all_1968.png',
    rating: 4.9,
    experience: '15 years',
    availableHours: { start: '09:00', end: '18:00' },
    phone: '(239) 201-8105',
    smsNotifications: true
  },
  {
    id: 2,
    name: 'Pee Wee (Yung Plane)',
    specialty: 'Classic Cuts & Shaves',
    avatar: 'https://customer-assets.emergentagent.com/job_barber-cape-coral/artifacts/o10vef2e_1022.png',
    rating: 4.8,
    experience: '15 years',
    availableHours: { start: '10:00', end: '19:00' },
    phone: '(239) 677-7182',
    smsNotifications: true
  },
  {
    id: 3,
    name: 'Alto (Toe)',
    specialty: 'Creative Styles & Kids',
    avatar: 'https://customer-assets.emergentagent.com/job_barber-cape-coral/artifacts/tt96in2p_1027.jpg',
    rating: 4.7,
    experience: '15 years',
    availableHours: { start: '08:30', end: '17:30' },
    phone: '(239) 645-8468',
    smsNotifications: true
  }
];

export const reviews = [
  {
    id: 1,
    customerName: 'John D.',
    rating: 5,
    comment: 'Best cut in Cape Coral! Marcus always delivers perfection.',
    date: '2024-01-15',
    service: 'Signature Haircut'
  },
  {
    id: 2,
    customerName: 'Marcus L.',
    rating: 5,
    comment: 'Stylish barbers and great vibe. Tony is a master with the razor.',
    date: '2024-01-10',
    service: 'Razor Shave'
  },
  {
    id: 3,
    customerName: 'Emily S.',
    rating: 4,
    comment: 'Kid-friendly and professional. DJ was amazing with my son!',
    date: '2024-01-08',
    service: 'Kids Haircut'
  },
  {
    id: 4,
    customerName: 'Carlos R.',
    rating: 5,
    comment: 'Clean shop, professional service. Worth every penny!',
    date: '2024-01-05',
    service: 'Haircut + Beard Combo'
  }
];

export const galleryImages = [
  { id: 1, url: 'https://customer-assets.emergentagent.com/job_barber-cape-coral/artifacts/ykhmlznz_951.jpg', alt: 'Fresh fade with precision lineup' },
  { id: 2, url: 'https://customer-assets.emergentagent.com/job_barber-cape-coral/artifacts/ztp3fxsg_828.jpg', alt: 'Textured top with clean fade' },
  { id: 3, url: 'https://customer-assets.emergentagent.com/job_barber-cape-coral/artifacts/y4opivb5_519.webp', alt: 'Clean taper fade with full beard' },
  { id: 4, url: 'https://customer-assets.emergentagent.com/job_barber-cape-coral/artifacts/33l8u8fy_240.webp', alt: 'Precision fade with styled beard' },
  { id: 5, url: 'https://customer-assets.emergentagent.com/job_barber-cape-coral/artifacts/4m0fy9ji_1042.jpg', alt: 'Sleek fade with textured top' },
  { id: 6, url: 'https://customer-assets.emergentagent.com/job_barber-cape-coral/artifacts/ntjk0vcz_1038.jpg', alt: 'Curly top fade with sharp lineup' }
];

// Initialize mock users in localStorage
export const initializeMockUsers = () => {
  if (!localStorage.getItem('users')) {
    const users = [
      {
        id: 1,
        email: 'admin@saucesity.com',
        password: 'admin123',
        role: 'admin',
        name: 'Admin User'
      },
      {
        id: 2,
        email: 'customer@example.com',
        password: 'customer123',
        role: 'customer',
        name: 'John Doe',
        phone: '(239) 555-0123',
        membershipTier: 'vip', // 'none', 'basic', 'vip'
        membershipStartDate: '2024-01-01',
        loyaltyPoints: 150,
        totalVisits: 15,
        referralCode: 'JOHND123',
        referrals: {
          bookings: 2,
          memberships: 1,
          total: 3,
          rewards: [
            { type: 'booking', discount: 10, used: false },
            { type: 'membership', discount: 25, used: false }
          ]
        }
      },
      {
        id: 3,
        email: 'member@example.com',
        password: 'member123',
        role: 'customer',
        name: 'Sarah Smith',
        phone: '(239) 555-0456',
        membershipTier: 'basic',
        membershipStartDate: '2024-02-15',
        loyaltyPoints: 80,
        totalVisits: 8,
        referralCode: 'SARAHS456',
        referrals: {
          bookings: 0,
          memberships: 0,
          total: 0,
          rewards: []
        }
      },
      {
        id: 4,
        email: 'taine@saucesity.com',
        password: 'taine123',
        role: 'barber',
        name: 'Taine (Sauce)',
        phone: '(239) 201-8105',
        membershipTier: 'none',
        loyaltyPoints: 0,
        totalVisits: 0
      },
      {
        id: 5,
        email: 'peewee@saucesity.com',
        password: 'peewee123',
        role: 'barber',
        name: 'Pee Wee (Yung Plane)',
        phone: '(239) 677-7182',
        membershipTier: 'none',
        loyaltyPoints: 0,
        totalVisits: 0
      },
      {
        id: 6,
        email: 'alto@saucesity.com',
        password: 'alto123',
        role: 'barber',
        name: 'Alto (Toe)',
        phone: '(239) 645-8468',
        membershipTier: 'none',
        loyaltyPoints: 0,
        totalVisits: 0
      },
      {
        id: 7,
        email: 'king@saucesity.com',
        password: 'king123',
        role: 'barber',
        name: 'King',
        phone: '(239) 201-8105',
        membershipTier: 'none',
        loyaltyPoints: 0,
        totalVisits: 0
      }
    ];
    localStorage.setItem('users', JSON.stringify(users));
  }
};

// Initialize mock appointments
export const initializeMockAppointments = () => {
  if (!localStorage.getItem('appointments')) {
    const appointments = [
      {
        id: 1,
        customerId: 2,
        customerName: 'John Doe',
        barberId: 1,
        barberName: 'Marcus Johnson',
        serviceId: 1,
        serviceName: 'Signature Haircut',
        date: '2024-01-25',
        time: '10:00',
        status: 'confirmed',
        notes: '',
        createdAt: '2024-01-20T10:00:00'
      },
      {
        id: 2,
        customerId: 2,
        customerName: 'John Doe',
        barberId: 2,
        barberName: 'Tony Martinez',
        serviceId: 5,
        serviceName: 'Razor Shave',
        date: '2024-01-28',
        time: '14:30',
        status: 'confirmed',
        notes: 'First time razor shave',
        createdAt: '2024-01-21T15:30:00'
      }
    ];
    localStorage.setItem('appointments', JSON.stringify(appointments));
  }
};

// Helper functions for localStorage management
export const getUsers = () => JSON.parse(localStorage.getItem('users') || '[]');
export const getAppointments = () => JSON.parse(localStorage.getItem('appointments') || '[]');
export const saveAppointments = (appointments) => localStorage.setItem('appointments', JSON.stringify(appointments));
export const saveUsers = (users) => localStorage.setItem('users', JSON.stringify(users));
